import { IHttpClient } from "../../lib/http";
import { addYears, format } from "date-fns";

export async function regenPropertyInventoryCalendar(
  httpClient: IHttpClient,
  propertyTicker: string
): Promise<void> {
  const startDateFormatted = format(new Date(), "yyyy-MM-dd");
  const endDateFormatted = format(addYears(new Date(), 1), "yyyy-MM-dd");
  return httpClient.put(
    `/api/hotel/${propertyTicker}/ari?startDate=${startDateFormatted}&endDate=${endDateFormatted}`,
    []
  );
}

export async function regenPropertyCalendar(
  httpClient: IHttpClient,
  propertyTicker: string
): Promise<void> {
  return httpClient.put(`/api/hotel/${propertyTicker}/ari/calendar`, undefined);
}
